// Dependencies
import React, { Component } from 'react';

class Testimonials extends Component {
  componentDidMount() {
    /* eslint-disable */
    $.HSCore.components.HSCarousel.init('.js-carousel');
  }

  render() {
    return (
      <div>
        <div className="clearfix g-bg-img-hero g-bg-pos-top-center g-bg-secondary g-pb-20 g-px-15 g-py-60">
          <div className="g-max-width-600 text-center mx-auto g-mb-60">
            <h2 className="g-color-gray-dark-v1 g-font-weight-600 g-font-size-30 mb-4">
              Nuestros clientes <span className="g-color-primary g-font-size-35">nos avalan</span>
            </h2>
            <p className="g-color-gray-dark-v3 g-font-size-18">
              La relación de confianza que desarrollamos con nuestros clientes para nosotros es un
              pilar fundamental.
            </p>
          </div>
          <div
            className="js-carousel u-carousel-v5 g-mb-60"
            data-slides-show="3"
            data-slides-scroll="1"
            data-pagi-classes="u-carousel-indicators-v35--main g-pos-rel text-center g-mt-30"
            data-responsive='[{
                            "breakpoint": 1200,
                            "settings": {
                                "slidesToShow": 1,
                                "slidesToScroll": 1
                            }
                            }, {
                            "breakpoint": 992,
                            "settings": {
                                "slidesToShow": 1,
                                "slidesToScroll": 1
                            }
                            }, {
                            "breakpoint": 768,
                            "settings": {
                                "slidesToShow": 1,
                                "slidesToScroll": 1
                            }
                            }, {
                            "breakpoint": 620,
                            "settings": {
                                "slidesToShow": 1,
                                "slidesToScroll": 1
                            }
                            }, {
                            "breakpoint": 446,
                            "settings": {
                                "slidesToShow": 1,
                                "slidesToScroll": 1
                            }
                            }]'>
            <div className="js-slide text-center g-px-15 g-mb-10">
              <div className="g-brd-around g-brd-gray-light-v5 g-bg-white rounded g-pa-40">
                <span className="u-icon-v1 g-width-70 g-height-70 g-color-white g-bg-primary-opacity-0_1 rounded-circle mb-4">
                  <i className="icon-bubbles g-color-primary"></i>
                </span>
                <blockquote className="g-color-gray-dark-v4 g-font-size-16--md g-line-height-1_8 g-mb-30">
                  Llevo casi 5 años trabajando con Insacom en el soporte informático de la empresa y
                  los resultados han sido los esperados, un sistema de información sencillo,
                  práctico y que se adapta a las necesidades que requiero.
                </blockquote>
                <h4 className="h6 g-color-gray-dark-v1 g-font-weight-600 text-uppercase mb-1">
                  Juan Manuel Maggi
                </h4>
                <span className="d-block g-color-gray-dark-v4 g-font-size-13">
                  Gerente Comercial - Áridos Livio Maggi
                </span>
              </div>
            </div>

            <div className="js-slide text-center g-px-15 g-mb-10">
              <div className="g-brd-around g-brd-gray-light-v5 g-bg-white rounded g-pa-40">
                <span className="u-icon-v1 g-width-70 g-height-70 g-color-white g-bg-primary-opacity-0_1 rounded-circle mb-4">
                  <i className="icon-bubbles g-color-primary"></i>
                </span>
                <blockquote className="g-color-gray-dark-v4 g-font-size-16--md g-line-height-1_8 g-mb-30">
                  Trabajamos con Insacom desde hace varios años en todas nuestras áreas TI, han sido
                  un apoyo fundamental para la transformación digital de la empresa.
                </blockquote>
                <h4 className="h6 g-color-gray-dark-v1 g-font-weight-600 text-uppercase mb-1">
                  Loreto Escandón
                </h4>
                <span className="d-block g-color-gray-dark-v4 g-font-size-13">
                  Gerente General - Soserval
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/subcomponents/Testimonials.js